module.exports = __webpack_public_path__ + "img/OEHU_SMART_METER.b6408bda.svg";